export default "__VITE_ASSET__BmB93xWD__"